import React, { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";

const AuthWrapper = ({ children }) => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    // 🚫 Don't trigger redirect during another redirect or popup
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      instance.loginRedirect(loginRequest);
    }
  }, [isAuthenticated, inProgress, instance]);

  // Optional: show loading UI while MSAL is busy
  if (inProgress !== InteractionStatus.None) {
    return <div style={{ textAlign: "center", marginTop: "25vh" }}>Signing in...</div>;
  }

  return <>{isAuthenticated && children}</>;
};

export default AuthWrapper;
